import { Link, useSearchParams } from 'react-router-dom';
import { Mixpanel, MxEvent } from './Mixpanel';
import { RAISE_TICKET_DEFAULTS, RAISE_TICKET_PLACEHOLDER } from '../constants/projectConstants';
import {
  MY_FILES_SHARED_FILES_IMAGES_ROUTE,
  RENDERS_PREVIEWS_ROUTE,
  RENDERS_PREVIEWS_ROUTE_V2,
  RENDER_DETAILS,
  RENDER_DETAILS_V2,
  SHARED_FILES_IMAGES_ROUTE
} from '../constants/routePathConstants';
import ThumbnailCardUI, { ACTION } from './ThumbnailCardUI';
import { apiEditRenderPreview, apiRetryRenderPreview } from '../helpers/api';
import { getDownloadAndCollect3DFileAction, getRenderStatusToHighlight } from '../helpers/jsHelper';

import { ARCHIVE_ICON } from '../constants/assetConstants';
import Loader from './Loader';
import { RENDER_IMAGE_TYPE } from '../constants/renderPreviewConstants';
import { FAST_PREVIEW_TAG, RENDER_STATUS } from '../constants/constants';
import { RestoreIcon } from '../components/icons/RestoreIcon';
import ThumbnailCardV2 from './ThumbnailCardV2';
import _ from 'lodash';
import { checkIfMemberHaveEditorAccess } from '../contexts/UserContext';
import { createTicketModalActions } from '../redux/slicers/createTicketModalSlicer';
import {
  getCuratorRenderPreviewPath,
  getCuratorRenderPreviewPathForMattress,
} from '../helpers/urlHelper';
import { icons } from '../assets';
import { myRenderPreviewActions } from '../redux/slicers/render_preview/myRenderPreviewSlice';
import styles from './ThumbnailCardUI.module.scss';
import { errorToast, successToast } from '../helpers/toastHelper';
import { useDispatch } from 'react-redux';
import { useRenderPreviewsActions } from '../hooks/useRenderPreviewsActions';
import { useUserContext } from '../contexts/UserContext';
import { PERMISSION } from '../constants/permissionConstants';
import { useStaticPermissions } from '../hooks/usePermissions';
import { useMemo } from 'react';

const { RetryIcon, HeadsetIcon, ArchiveIcon } = icons;

export const ThumbnailCardRenderPreviews = ({
  data,
  size,
  hideFavourite,
  onEdit,
  onDelete,
  to = RENDER_DETAILS_V2,
  customActions,
  designV2,
  redirect,
  showMenu,
  isSharedItem,
  activeIndex,
  setActiveIndex,
  ...rest
}) => {
  const { isGuestUser, canDownload3DFile } = useUserContext();
  const [params] = useSearchParams();
  const { hasPermission } = useStaticPermissions();

  const {
    onDelete: _onDelete,
    onRetry,
    retryLoading,
    onFavouriteToggle,
    favouriteLoading,
    onShare,
    onDownloadClick,
    downloadLoading,
    addToCollection,
    requestTo3DFilesCollection,
    download3DFilesZip,
  } = useRenderPreviewsActions({
    item: data,
  });

  const dispatch = useDispatch();
  const isArchived = data?.is_archived;
  const isAutomationOrOldObject = data?.is_automation && data?.is_old_obj;
  const isUpload = data?.is_upload;

  const angleName = data?.images?.[0]?.angle_name;
  let url = angleName
    ? getCuratorRenderPreviewPath(data.id, angleName, data?.is_automation)
    : getCuratorRenderPreviewPath(data.id, '', data?.is_automation);

  if (data?.is_product_builder) {
    url = getCuratorRenderPreviewPathForMattress({ data, fallbackUrl: url });
  }

  let handleEdit;
  if (!isUpload) {
    handleEdit = () => {
      if (!checkIfMemberHaveEditorAccess()) return;

      if (onEdit) onEdit?.();
      else {
        Mixpanel.track(true, MxEvent.EDIT_IN_3D_IMAGE, {
          image_id: data?.id,
          image_name: data?.name,
          image_angle_name: '',
        });

        Mixpanel.track(true, MxEvent.CURATOR_STARTED, {
          'Curator project type': 'render',
          'Curator opened from': 'Edit button on render thumbnail',
          'Render id': data?.id,
          'Render name': data?.name,
          'Render isFavourite': data?.is_favourite,
          'Render creator id': data?.member_details?.id,
          'Render creator name': data?.member_details?.name,
          'Render creator email': data?.member_details?.email,
          'Render created at': data?.created_at,
          'Render room': data?.room,
          'Render associate room': data?.associate_room,
        });
        window.open(url, '_blank');
      }
    };
  }

  const handleDelete = onDelete || _onDelete;

  const current = data.images?.filter((a) => a.status === RENDER_STATUS.STATUS_DONE).length;
  const max = data.images?.length || 0;

  const bottomRightText = `Status: ${current}/${max}`;
  let actions = customActions;
  if (!actions) {
    actions = data.is_main_render
      ? {
          [ACTION.DELETE]: {
            label: 'Archive',
            icon: designV2 ? ArchiveIcon : <img src={ARCHIVE_ICON} alt="Archive" />,
          },
        }
      : undefined;
  }

  // remove for beta
  // const onRaiseTicket = () => {
  //   const ticketData = Object.assign({}, RAISE_TICKET_DEFAULTS.RENDERS_PREVIEWS)
  //   ticketData.title = ticketData.title.replace(RAISE_TICKET_PLACEHOLDER, data.name)

  //   if(!_.isEqual(ticketData, RAISE_TICKET_DEFAULTS.RENDERS_PREVIEWS)) {
  //     dispatch(createTicketModalActions.show(ticketData));
  //   }
  // }

  if (!actions) {
    actions = {};
  }

  if (canDownload3DFile) {
    // generating download & collect 3d files
    actions = getDownloadAndCollect3DFileAction({
      actions,
      data,
      rest,
      designV2,
      download3DFilesZip,
      requestTo3DFilesCollection,
      onUpdate: (updatedData) => dispatch(myRenderPreviewActions.update(updatedData)),
    });
  }

  const onRestore = async (id) => {
    dispatch(myRenderPreviewActions.deleteStart({ itemId: id }));
    successToast('Render restored successfully.');
    const payload = {
      is_archived: false,
    };
    const res = await apiEditRenderPreview(id, payload, null, null, '?is_archived=true');
    if (res.status) {
      dispatch(myRenderPreviewActions.deleteSuccess({ itemId: id }));
    } else dispatch(myRenderPreviewActions.deleteFailed({ itemId: id }));
  };

  const onRestoreCollectionPage = async (id) => {
    const payload = {
      is_archived: false,
    };
    const res = await apiEditRenderPreview(id, payload, null, null, '?is_archived=true');
    if (res.status) {
      successToast('Render restored successfully.');
      rest?.refetchList && rest?.refetchList?.();
    }
  };

  let showActionsText = false;

  if (data?.status === RENDER_STATUS.STATUS_NOT_DONE) {
    actions = {
      [ACTION.RETRY]: { onClick: null },
      [ACTION.RAISE_TICKET]: { onClick: null },
      [ACTION.DOWNLOAD]: { onClick: null },
      [ACTION.SHARE]: { onClick: null },
      [ACTION.ADD_TO_COLLECTION]: { onClick: null },
      [ACTION.DELETE]: { onClick: null },
      [ACTION?.COLLECT_3D_FILES]: { onClick: null },
      [ACTION?.DOWNLOAD_3D_FILES]: { onClick: null },
    };
    showActionsText = true;
  }

  if (data?.status === RENDER_STATUS.STATUS_FAILED) {
    actions = {
      [ACTION.RETRY]: {
        label: 'Retry',
        icon: RetryIcon,
        onClick: onRetry,
      },
      [ACTION.RAISE_TICKET]: { onClick: null }, // { label: 'Raise Ticket', icon: designV2 ? HeadsetIcon : <HeadsetIcon />, onClick: onRaiseTicket }, // remove for beta
      [ACTION.DOWNLOAD]: { onClick: null },
      [ACTION.EDIT]: { onClick: null },
      [ACTION.SHARE]: { onClick: null },
      [ACTION.ADD_TO_COLLECTION]: { onClick: null },
      [ACTION.DELETE]: { onClick: null },
      [ACTION?.COLLECT_3D_FILES]: { onClick: null },
      [ACTION?.DOWNLOAD_3D_FILES]: { onClick: null },
    };
    showActionsText = true;
  }

  // under review status is not done yet
  // if(data?.status === RENDER_STATUS.STATUS_UNDER_REVIEW) {
  //   actions = {
  //     [ACTION.RETRY]: { onClick: null },
  //     [ACTION.RAISE_TICKET]: { onClick: null },
  //     [ACTION.UNDER_REVIEW]: { label: 'Under Review', icon: designV2 ? HeadsetIcon : <HeadsetIcon />, onClick: null },
  //     [ACTION.DOWNLOAD]: {onClick: null},
  //     [ACTION.EDIT]: {onClick: null},
  //     [ACTION.SHARE]: {onClick: null},
  //     [ACTION.ADD_TO_COLLECTION]: {onClick: null},
  //     [ACTION.DELETE]: {onClick: null}
  //   }
  //  showActionsText = true;
  // }

  if (isUpload) {
    const localActions = {
      [ACTION.RETRY]: { onClick: null },
      [ACTION.RAISE_TICKET]: { onClick: null },
      [ACTION.RESTORE]: { onClick: null },
      [ACTION.EDIT]: { onClick: null },
    };

    if (rest?.isCollectionItem) {
      actions = {
        ...localActions,
        [ACTION.DELETE]: {
          label: 'Remove from collection',
          onClick: actions[ACTION.DELETE].onClick,
        },
      };
    } else {
      actions = localActions;
    }
    showActionsText = false;
  }

  if (isArchived) {
    actions = {
      [ACTION.RETRY]: { onClick: null },
      [ACTION.RAISE_TICKET]: { onClick: null },
      [ACTION.RESTORE]: {
        label: 'Restore',
        icon: designV2 ? RestoreIcon : <RestoreIcon />,
        onClick: rest?.isCollectionItem ? onRestoreCollectionPage : onRestore,
      },
      [ACTION.DOWNLOAD]: { onClick: null },
      [ACTION.EDIT]: { onClick: null },
      [ACTION.SHARE]: { onClick: null },
      [ACTION.ADD_TO_COLLECTION]: { onClick: null },
      [ACTION.DELETE]: { onClick: null },
      [ACTION?.COLLECT_3D_FILES]: { onClick: null },
      [ACTION?.DOWNLOAD_3D_FILES]: { onClick: null },
    };
    showActionsText = true;
  }

  let titleProps;
  const archiveParam = `&render_type=archive`;

  to = to + `?${params}${isArchived ? archiveParam : ''}`;

  if (data?.is_automation) {
    to += '&automation=true';
  }

  if (isArchived) {
    titleProps = {
      as: Link,
      target: '_blank',
      to: to.replace(':id', data?.id),
    };
  } else if (isUpload) {
    titleProps = {
      as: Link,
      target: '_blank',
      to: to.replace(':id', data?.id),
    };
  } else {
    titleProps = {
      as: Link,
      target: '_blank',
      to: isAutomationOrOldObject ? to : url,
    };
  }

  const handleOpenCurator = () => {
    Mixpanel.track(true, MxEvent.EDIT_IN_3D_IMAGE, {
      image_id: data?.id,
      image_name: data?.name,
      image_angle_name: '',
    });

    Mixpanel.track(true, MxEvent.CURATOR_STARTED, {
      'Curator project type': 'render',
      'Curator opened from': 'Title on render thumbnail',
      'Render id': data?.id,
      'Render name': data?.name,
      'Render isFavourite': data?.is_favourite,
      'Render creator id': data?.member_details?.id,
      'Render creator name': data?.member_details?.name,
      'Render creator email': data?.member_details?.email,
      'Render created at': data?.created_at,
      'Render associate room': data?.associate_room,
    });
  };

  titleProps = {
    ...(data?.is_product_builder && !url ? {} : titleProps), // removing the link if the url is empty for product builder
    onClick: (e) => {
      if (!checkIfMemberHaveEditorAccess()) {
        e.preventDefault();
        return;
      }
      handleOpenCurator();

      if (data?.is_product_builder && !url)
        errorToast('Project not found. It may have been deleted.');
    },
  };

  const isFilmicImgType = data?.img_type === RENDER_IMAGE_TYPE.FILMIC;

  // showing the default rendered image on card carousel
  const updatedImages = data?.images.map((a) => {
    const filmic = a.is_tiff ? a.extra_filmic_file : a.filmic_file;
    const file = a.is_tiff ? a.extra_file : a.file;
    const uthumbnail = a?.is_filmic ? filmic : file;

    if (isFilmicImgType) {
      return {
        ...a,
        thumbnail: a?.filmic_thumbnail || uthumbnail,
      };
    }

    return {
      ...a,
      thumbnail: a?.thumbnail || uthumbnail,
    };
  });

  let pageMainUrl = RENDERS_PREVIEWS_ROUTE_V2;
  if (isSharedItem) {
    pageMainUrl = MY_FILES_SHARED_FILES_IMAGES_ROUTE.replace('/:renderId', '');
  }

  const redirectURL = `${pageMainUrl}/${data?.id}?cameraName=${updatedImages?.[0]?.angle_name}${
    isArchived ? '&render_type=archive' : ''
  }${data?.is_automation ? '&automation=true' : ''}`;

  const handleEditWithFastPreview = () => {
    if (!checkIfMemberHaveEditorAccess()) return;

    let _url = url + `&${FAST_PREVIEW_TAG}=true`;
    handleOpenCurator();
    window.open(_url, '_blank');
  };

  const tagList = useMemo(() => {
    if (data.is_retail_automation || data.is_retail_automation_configurator) {
      return [
        {
          label: data.is_greyscale_render ? 'Artistic' : 'Realistic',
        },
      ];
    }

    return [];
  }, [data]);

  const tagListStyle = {
    right: 0,
    top: 0,
  };

  return designV2 ? (
    <ThumbnailCardV2
      activeIndex={activeIndex}
      setActiveIndex={setActiveIndex}
      onFavouriteChange={onFavouriteToggle(data)}
      onSelect={rest?.onSelect}
      selected={rest?.selected}
      isFavourite={data.is_favourite}
      hideFavourite={hideFavourite}
      favouriteLoading={favouriteLoading}
      titleProps={
        isGuestUser() || !redirect
          ? null
          : {
              ...titleProps,
              target: isArchived ? '_self' : '_blank',
              to: isArchived ? redirectURL : url,
            }
      }
      savePreviousRoute={true}
      id={data?.id}
      target="_blank"
      data={data}
      name={data?.name}
      thumbnail={updatedImages?.[0]?.thumbnail}
      images={updatedImages}
      date={data?.created_at}
      bottomRightText={bottomRightText}
      showMenu={showMenu && !isGuestUser()}
      userCard
      showCheckbox
      isFavouriteIcon
      downloadLoading={downloadLoading}
      onEdit={
        isArchived || isUpload || isAutomationOrOldObject || data?.is_product_builder
          ? null
          : handleEdit
      }
      onDelete={isAutomationOrOldObject ? null : handleDelete}
      onAddToCollection={addToCollection}
      onDownload={onDownloadClick}
      onShare={data?.is_product_builder && data?.type === '9' ? null : onShare} // Temporary hide: Hide share option for product builder renders with Silo template (type '9')
      customActions={actions}
      redirect={redirect}
      redirectTarget="_self"
      redirectURL={redirectURL}
      highlight={getRenderStatusToHighlight(data?.status)}
      onEditWithFastPreview={
        isGuestUser() || hasPermission(PERMISSION.CAN_USE_FAST_PREVIEW)
          ? handleEditWithFastPreview
          : null
      }
      tagList={tagList}
      tagListStyle={tagListStyle}
      {...rest}
    />
  ) : (
    <ThumbnailCardUI
      key={data.id}
      id={data.id}
      to={isArchived ? to.replace(':id', data?.id) : to}
      onEdit={
        isArchived || isUpload || isAutomationOrOldObject || data?.is_product_builder
          ? null
          : handleEdit
      }
      images={updatedImages}
      name={data.name || data.render_name}
      isFavourite={data.is_favourite}
      favouriteLoading={favouriteLoading}
      date={data.updated_at}
      onDelete={isAutomationOrOldObject ? null : handleDelete}
      bottomRightText={bottomRightText}
      onShare={data?.is_product_builder && data?.type === '9' ? null : onShare} // Temporary hide: Hide share option for product builder renders with Silo template (type '9')
      customActions={actions}
      onFavouriteChange={onFavouriteToggle(data)}
      size={size}
      titleProps={isGuestUser() ? null : titleProps}
      downloadLoading={downloadLoading}
      // imageFit="contain"
      onAddToCollection={addToCollection}
      onDownload={onDownloadClick}
      // onDownload={!data.is_preview && onDownloadClick}
      hideFavourite={hideFavourite}
      highlight={getRenderStatusToHighlight(data?.status)}
      actionsListClassName={
        isArchived ? styles.actionListSpaceAround : styles.actionListSpaceBetween
      }
      showActionsText={showActionsText}
      data={data}
      onEditWithFastPreview={
        isGuestUser() || hasPermission(PERMISSION.CAN_USE_FAST_PREVIEW)
          ? handleEditWithFastPreview
          : null
      }
      tagList={tagList}
      tagListStyle={tagListStyle}
      {...rest}
    />
  );
};
